//Sets dimensions
var margin = {top: 10, left: 0, bottom: 10, right: 0},
  width = d3.select(".gia-chart").node().clientWidth,
  width = width - margin.left - margin.right,
  mapRatio = .6,
  height = width * mapRatio;

//Tells the map what projection to use
var projection = d3.geo.albersUsa()
  .scale(width *1.25)
  .translate([width / 2, height / 2]);

//Tells the map how to draw the paths from the projection
var path = d3.geo.path()
  .projection(projection);

var color = d3.scale.ordinal()
  .domain(["R", "D", "Y"])
  .range(["#d61d00", "#005689", "#dcdcdc"])    

//Appened svg to page
var map = d3.select(".gia-chart").append("svg")
  .style('height', height + 'px')
  .style('width', width + 'px');  

//Load the files
queue()
  .defer(d3.json, "data/usmap.json")
  .defer(d3.csv, "data/states.csv")
  .await(ready);

function ready(error, us, maptemplate) {
  if (error) throw error;  
 
  //Pair data with state id
  var dataByFIPS = {};
  maptemplate.forEach(function(d) { dataByFIPS[d.FIPS] = d.num; });

  //Pair state name with state id
  var stateabByFIPS = {};
  maptemplate.forEach(function(d) { stateabByFIPS[d.FIPS] = d.abbrev; });

  //Pair cat name with state id
  var catByFIPS = {};
  maptemplate.forEach(function(d) { catByFIPS[d.FIPS] = d.cat; });

  //Append states
  map.append("g")
    .attr("class", "states")
    .selectAll("path")
    .data(topojson.feature(us, us.objects.states).features)
    .enter().append("path")
    .attr("d", path)
    .style("fill", function(d) { return color(catByFIPS[d.id]); })

  //RESPONSIVENESS
  d3.select(window).on('resize', resize);

  function resize() {

    var w = d3.select(".gia-chart").node().clientWidth;

    //Adjust things when the window size changes
    width = w - margin.left - margin.right;
    height = width * mapRatio;
    
    //Update projection
    var newProjection = d3.geo.albersUsa()
      .scale(width*1.25)
      .translate([width / 2, height / 2]);

    //Update path
    path = d3.geo.path()
      .projection(newProjection);    

    //Resize the map container
    map
      .style('width', width + 'px')
      .style('height', height + 'px');

    //Resize the map
    map.selectAll("path").attr('d', path);
  }
}